import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'id',
  })
  let treatment_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.ledger.treatment_id',
  })
  let location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.ledger.location_id',
  })
  let payors = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.ledger.payors',
  })
  let order = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.ledger.order',
  })

  return {
    variables: {
      where: {
        patient_id: { _eq: patient_id },
        treatment_id: treatment_id ? { _eq: treatment_id } : undefined,
        organization_id: location_id ? { _eq: location_id } : undefined,
        _or: payors.length
          ? payors.map(p => ({
              payment_account_id: { _eq: p.payment_account_id },
              insured_id:
                p.insured_id !== null
                  ? { _eq: p.insured_id }
                  : { _is_null: true },
            }))
          : undefined,
        // exclude cancelled receivables
        _not: { cancelled_receivables: {} },
      },
      order,
    },
    pause: !patient_id,
    // Note: adding or modifying receivables is only available through old UI
    // we may be able to change it to cache-only once everything is added through the new UI so it reflects the changes automatically
    requestPolicy: 'cache-and-network',
  }
}
